// GENERAL CONSTANTS 

export const READ_DATA_REQUEST = "READ_DATA_REQUEST"
export const READ_DATA_SUCCESS = "READ_DATA_SUCCESS"
export const READ_DATA_FAILURE = "READ_DATA_FAILURE"


export const UPDATE_SETTINGS_REQUEST = "UPDATE_SETTINGS_REQUEST"
export const UPDATE_SETTINGS_SUCCESS = "UPDATE_SETTINGS_SUCCESS"
export const UPDATE_SETTINGS_FAILURE = "UPDATE_SETTINGS_FAILURE"

// GENERAL CONSTANTS 


// USER CONSTANTS 

export const LOGIN_REQUEST = "LOGIN_REQUEST"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAILURE = "LOGIN_FAILURE"

export const LOGOUT = "LOGOUT"

export const CREATE_USER_REQUEST = "CREATE_USER_REQUEST"
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS"
export const CREATE_USER_FAILURE = "CREATE_USER_FAILURE"

export const READ_USER_REQUEST = "READ_USER_REQUEST"
export const READ_USER_SUCCESS = "READ_USER_SUCCESS"
export const READ_USER_FAILURE = "READ_USER_FAILURE"

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST"
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS"
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE"

export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST"
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS"
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE"


export const CREATE_SHIPPING_INFO_REQUEST = "CREATE_SHIPPING_INFO_REQUEST"
export const CREATE_SHIPPING_INFO_SUCCESS = "CREATE_SHIPPING_INFO_SUCCESS"
export const CREATE_SHIPPING_INFO_FAILURE = "CREATE_SHIPPING_INFO_FAILURE"

export const READ_SHIPPING_INFO_REQUEST = "READ_SHIPPING_INFO_REQUEST"
export const READ_SHIPPING_INFO_SUCCESS = "READ_SHIPPING_INFO_SUCCESS"
export const READ_SHIPPING_INFO_FAILURE = "READ_SHIPPING_INFO_FAILURE"

export const UPDATE_SHIPPING_INFO_REQUEST = "UPDATE_SHIPPING_INFO_REQUEST"
export const UPDATE_SHIPPING_INFO_SUCCESS = "UPDATE_SHIPPING_INFO_SUCCESS"
export const UPDATE_SHIPPING_INFO_FAILURE = "UPDATE_SHIPPING_INFO_FAILURE"

// USER CONSTANTS 


// SHOP CONSTANTS

export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST"
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS"
export const CREATE_PRODUCT_FAILURE = "CREATE_PRODUCT_FAILURE"

export const READ_PRODUCT_REQUEST = "READ_PRODUCT_REQUEST"
export const READ_PRODUCT_SUCCESS = "READ_PRODUCT_SUCCESS"
export const READ_PRODUCT_FAILURE = "READ_PRODUCT_FAILURE"

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST"
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS"
export const UPDATE_PRODUCT_FAILURE = "UPDATE_PRODUCT_FAILURE"

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST"
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE"



export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST"
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS"
export const CREATE_ORDER_FAILURE = "CREATE_ORDER_FAILURE"

export const READ_ORDER_REQUEST = "READ_ORDER_REQUEST"
export const READ_ORDER_SUCCESS = "READ_ORDER_SUCCESS"
export const READ_ORDER_FAILURE = "READ_ORDER_FAILURE"

export const UPDATE_ORDER_REQUEST = "UPDATE_ORDER_REQUEST"
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS"
export const UPDATE_ORDER_FAILURE = "UPDATE_ORDER_FAILURE"


export const READ_ORDER_HISTORY_REQUEST = "READ_ORDER_HISTORY_REQUEST"
export const READ_ORDER_HISTORY_SUCCESS = "READ_ORDER_HISTORY_SUCCESS"
export const READ_ORDER_HISTORY_FAILURE = "READ_ORDER_HISTORY_FAILURE"


export const READ_INVENTORY_REQUEST = "READ_INVENTORY_REQUEST"
export const READ_INVENTORY_SUCCESS = "READ_INVENTORY_SUCCESS"
export const READ_INVENTORY_FAILURE = "READ_INVENTORY_FAILURE"


export const CREATE_TEMP_CART = "CREATE_TEMP_CART"
export const ADD_TEMP_ITEM = "ADD_TEMP_ITEM"
export const EDIT_TEMP_ITEM = "EDIT_TEMP_ITEM"
export const DELETE_TEMP_ITEM = "DELETE_TEMP_ITEM"
export const EMPTY_CART = "EMPTY_CART"


export const READ_TECH_ORDER_REQUEST = "READ_TECH_ORDER_REQUEST"
export const READ_TECH_ORDER_SUCCESS = "READ_TECH_ORDER_SUCCESS"
export const READ_TECH_ORDER_FAILURE = "READ_TECH_ORDER_FAILURE"

export const UPDATE_TECH_ORDER_REQUEST = "UPDATE_TECH_ORDER_REQUEST"
export const UPDATE_TECH_ORDER_SUCCESS = "UPDATE_TECH_ORDER_SUCCESS"
export const UPDATE_TECH_ORDER_FAILURE = "UPDATE_TECH_ORDER_FAILURE"



export const READ_WAREHOUSE_DATA_REQUEST = "READ_WAREHOUSE_DATA_REQUEST"
export const READ_WAREHOUSE_DATA_SUCCESS = "READ_WAREHOUSE_DATA_SUCCESS"
export const READ_WAREHOUSE_DATA_FAILURE = "READ_WAREHOUSE_DATA_FAILURE"

export const UPDATE_WAREHOUSE_DATA_REQUEST = "UPDATE_WAREHOUSE_DATA_REQUEST"
export const UPDATE_WAREHOUSE_DATA_SUCCESS = "UPDATE_WAREHOUSE_DATA_SUCCESS"
export const UPDATE_WAREHOUSE_DATA_FAILURE = "UPDATE_WAREHOUSE_DATA_FAILURE"



export const CREATE_PENDING_ORDER_REQUEST = "CREATE_PENDING_ORDER_REQUEST"
export const CREATE_PENDING_ORDER_SUCCESS = "CREATE_PENDING_ORDER_SUCCESS"
export const CREATE_PENDING_ORDER_FAILURE = "CREATE_PENDING_ORDER_FAILURE"

export const READ_PENDING_ORDER_REQUEST = "READ_PENDING_ORDER_REQUEST"
export const READ_PENDING_ORDER_SUCCESS = "READ_PENDING_ORDER_SUCCESS"
export const READ_PENDING_ORDER_FAILURE = "READ_PENDING_ORDER_FAILURE"

export const UPDATE_PENDING_ORDER_REQUEST = "UPDATE_PENDING_ORDER_REQUEST"
export const UPDATE_PENDING_ORDER_SUCCESS = "UPDATE_PENDING_ORDER_SUCCESS"
export const UPDATE_PENDING_ORDER_FAILURE = "UPDATE_PENDING_ORDER_FAILURE"


export const CREATE_SUPPLIER_REQUEST = "CREATE_SUPPLIER_REQUEST"
export const CREATE_SUPPLIER_SUCCESS = "CREATE_SUPPLIER_SUCCESS"
export const CREATE_SUPPLIER_FAILURE = "CREATE_SUPPLIER_FAILURE"

export const READ_SUPPLIER_REQUEST = "READ_SUPPLIER_REQUEST"
export const READ_SUPPLIER_SUCCESS = "READ_SUPPLIER_SUCCESS"
export const READ_SUPPLIER_FAILURE = "READ_SUPPLIER_FAILURE"

export const UPDATE_SUPPLIER_REQUEST = "UPDATE_SUPPLIER_REQUEST"
export const UPDATE_SUPPLIER_SUCCESS = "UPDATE_SUPPLIER_SUCCESS"
export const UPDATE_SUPPLIER_FAILURE = "UPDATE_SUPPLIER_FAILURE"



export const CREATE_PACKAGE_REQUEST = "CREATE_PACKAGE_REQUEST"
export const CREATE_PACKAGE_SUCCESS = "CREATE_PACKAGE_SUCCESS"
export const CREATE_PACKAGE_FAILURE = "CREATE_PACKAGE_FAILURE"

export const READ_PACKAGE_REQUEST = "READ_PACKAGE_REQUEST"
export const READ_PACKAGE_SUCCESS = "READ_PACKAGE_SUCCESS"
export const READ_PACKAGE_FAILURE = "READ_PACKAGE_FAILURE"

export const UPDATE_PACKAGE_REQUEST = "UPDATE_PACKAGE_REQUEST"
export const UPDATE_PACKAGE_SUCCESS = "UPDATE_PACKAGE_SUCCESS"
export const UPDATE_PACKAGE_FAILURE = "UPDATE_PACKAGE_FAILURE"



export const CREATE_TECH_PACKAGE_REQUEST = "CREATE_TECH_PACKAGE_REQUEST"
export const CREATE_TECH_PACKAGE_SUCCESS = "CREATE_TECH_PACKAGE_SUCCESS"
export const CREATE_TECH_PACKAGE_FAILURE = "CREATE_TECH_PACKAGE_FAILURE"

export const READ_TECH_PACKAGE_REQUEST = "READ_TECH_PACKAGE_REQUEST"
export const READ_TECH_PACKAGE_SUCCESS = "READ_TECH_PACKAGE_SUCCESS"
export const READ_TECH_PACKAGE_FAILURE = "READ_TECH_PACKAGE_FAILURE"

export const UPDATE_TECH_PACKAGE_REQUEST = "UPDATE_TECH_PACKAGE_REQUEST"
export const UPDATE_TECH_PACKAGE_SUCCESS = "UPDATE_TECH_PACKAGE_SUCCESS"
export const UPDATE_TECH_PACKAGE_FAILURE = "UPDATE_TECH_PACKAGE_FAILURE"

export const DELETE_TECH_PACKAGE_REQUEST = "DELETE_TECH_PACKAGE_REQUEST"
export const DELETE_TECH_PACKAGE_SUCCESS = "DELETE_TECH_PACKAGE_SUCCESS"
export const DELETE_TECH_PACKAGE_FAILURE = "DELETE_TECH_PACKAGE_FAILURE"

// SHOP CONSTANTS



// TABLE CONSTANTS

export const SET_TABLE_FILTER = "SET_TABLE_FILTER"
export const SET_VIEW_FILTER = "SET_VIEW_FILTER"
export const SET_PAGE_FILTER = "SET_PAGE_FILTER"
export const GENERATE_FILTERS = "GENERATE_FILTERS"

// TABLE CONSTANTS

export const statuses = {
    idle: "",
    pending: "pending",
    success: "success",
    failure: "failure"
}